const axios = require("axios");
module.exports.init = me => {
  //Collections
  me.getItemSchemas = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/item-schemas`, data, {
      headers: {
        ...me.globalHeaders
      }
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
};